/**
 * Honor Rankings Service Module
 *
 * Manages honor points and user rankings.
 */

import { api } from './client';
import type { HonorListResponse, PaginationParams } from './types';

/**
 * Honor API
 *
 * Endpoints for honor rankings and leaderboards.
 */
export const honorAPI = {
  /**
   * Get honor rankings
   *
   * Retrieves honor rankings and leaderboards.
   *
   * **Endpoint:** GET /api/honor/
   * **Protected:** No
   * **Method:** GET
   *
   * @param params - Pagination parameters
   * @returns Honor rankings list
   * @throws ApiError on failure
   *
   * @example
   * ```typescript
   * const rankings = await honorAPI.getRankings({ page: 1, limit: 20 });
   * ```
   */
  getRankings: async (params?: PaginationParams): Promise<HonorListResponse> =>
    api.get<HonorListResponse>('/api/honor', params),

  getList: async (params?: PaginationParams): Promise<HonorListResponse> =>
    api.get<HonorListResponse>('/api/honor', params),
};
